import { FC } from 'react';

import Flex from 'quarks/Flex';
import type { BasicProps } from 'quarks/interpolations/basic';

import MobileMenuItem from 'components/Header/Mobile/MenuItem';

export interface MobileMenuProps extends BasicProps {
  elementMenu?: any[]; // Replace 'any' with the actual type for elementMenu
  isMobileNavOpen?: boolean;
  mobileHeaderHeight?: string;
  openMenu?: number;
  parentOpen?: boolean;
  openMenuGroup?: number;
  setIsMobileNavOpen?: () => void;
  setOpenMenu?: () => void;
}

const MobileMenuChildMenu: FC<MobileMenuProps> = ({
  elementMenu,
  mobileHeaderHeight,
  openMenu = -1,
  openMenuGroup,
  setIsMobileNavOpen,
  setOpenMenu,
  parentOpen,
}) => (
  <Flex
    className={`mobile-child-menu ${parentOpen === false ? 'open' : 'false'}`}
    position="absolute"
    left="0"
    width="100vw"
    height="100vh"
    transition="height 0.3s ease-in-out"
    backgroundColor="common-white"
    zIndex={10}
    overflowX="scroll"
    overflowY="scroll"
    flexDirection="column"
    css={`
      padding-top: ${mobileHeaderHeight};

      .mobile-menu-item {
        flex-direction: column;
        padding: 25px;
        gap: 35px;
        overflow: scroll;
        height: 100%;

        h4 {
          padding: 0;
        }
      }

      .sub-menu-group {
        gap: 25px;
      }
    `}
  >
    {elementMenu?.map((parent, index) => (
      <MobileMenuItem
        key={`menu-item-${index}`}
        menu={parent}
        isOpen={index === openMenu}
        heading={parent.heading}
        openMenuGroup={openMenuGroup}
        setIsMobileNavOpen={setIsMobileNavOpen}
        setOpenMenu={setOpenMenu}
      />
    ))}
  </Flex>
);

export default MobileMenuChildMenu;
